import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

const Collateral = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext();

  return (
    <Card className="mb-3">
      <Card.Header as="h6" className="bg-light">
        Барьцаа
      </Card.Header>
      <Card.Body>
        <Row className="gx-2 gy-3">
          <Col md="12">
            <Form.Group>
              <Form.Label>Барьцаа хөрөнгийн төрөл:</Form.Label>
              <Form.Control
                type="text"
                isInvalid={!!errors.collateralType}
                {...register('collateralType')}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.collateralType?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md="12">
            <Form.Group>
              <Form.Label>Барьцаа хөрөнгийн мэдээлэл:</Form.Label>
              <Form.Control
                type="text"
                isInvalid={!!errors.collateralInfo}
                {...register('collateralInfo')}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.collateralInfo?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md="12">
            <Form.Group>
              <Form.Label>Барьцаа хөрөнгө үнэлгээ: (₮)</Form.Label>
              <Form.Control
                type="text"
                isInvalid={!!errors.collateralPrice}
                {...register('collateralPrice')}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.collateralPrice?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Collateral;
